<template>
  <div class="titleCard">
    <div class="left">
      <div class="title">已保存的广告标题</div>
      <div class="leftBox">
        <div class="btnBar">
          <span class="total">共{{this.savedTitleList.length}}条</span>
          <div class="btn">
            <el-button type="text" @click="edit">{{ readonly ? '编辑' : '完成编辑' }}</el-button>
            <el-button type="text" @click="copy">复制</el-button>
            <el-button type="text" @click="fillTo" v-show="aiModel===2">填充到方案</el-button>
            <!--            <el-button type="text" @click="addTo">添加到账户</el-button>-->
          </div>
        </div>
        <div class="info">
          <el-input
              type="textarea"
              :rows="25"
              placeholder=""
              resize="none"
              :readonly="readonly"
              v-model="textarea">
          </el-input>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="title">广告标题生成结果
        <div>
          <el-button type="primary" size="mini" @click="clearTitle">清空</el-button>
          <el-button type="primary" size="mini" @click="$emit('remake')" :disabled="titleLoading">
            {{ titleLoading ? '正在生成' : '重新生成' }}
          </el-button>
          <el-button type="primary" size="mini" :disabled="titleLoading" @click="dialogVisible=true">AI修改
          </el-button>
        </div>
      </div>
      <div class="rightBox" v-loading="titleLoading" element-loading-text="AI生成中...">
        <div class="btnBar">
          <span class="total">广告标题</span>
        </div>
        <div class="info">
          <div class="listItem" v-for="i in titleList" :key="i.id">
            <div class="listItemLeft">
              <div class="leftTop">{{ i.content }}</div>
              <div class="leftBottom">{{ i.zhContent }}</div>
            </div>
            <div class="listItemRight">
              <el-link :underline="false" icon="el-icon-document" @click="save(i)">保存</el-link>
              <el-link :underline="false" icon="el-icon-delete" @click="$emit('del',i)">删除</el-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="AI修改"
        :visible.sync="dialogVisible"
        width="30%"
        :modal="false"
    >
      <el-row>
        <el-col>
          <el-input placeholder="请输入内容" v-model="modifyText">
            <template slot="append">
              <el-button icon="el-icon-s-promotion" @click="aiModify(modifyText)"></el-button>
            </template>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button type="text" @click="aiModify('再写10条')">再写10条</el-button>
          <el-button type="text" @click="aiModify('拓长尾词')">拓长尾词</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import {mapState} from "vuex";
import sem from "@/backend/services/sem/sem";

export default {
  name: 'titleCard',
  props: {
    titleLoading: {
      type: Boolean,
      default: false
    },
    titleList: {
      type: Array,
      default: () => []
    },
    programmeDetailId: String
  },
  data() {
    return {
      textarea: '',
      readonly: true,
      dialogVisible: false,
      modifyText: '',
      savedTitleList: [],
    }
  },
  computed: {
    ...mapState({
      aiModel: state => state.aiAds.aiModel,
      currentInfo: state => state.aiAds.currentInfo
    })
  },
  watch:{
    programmeDetailId: {
      handler(val) {
        if (val) {
          this.getAdsTitle()
        }
      }
    }
  },
  mounted() {
    this.getAdsTitle()
  },
  methods: {

    // AI修改
    aiModify(text) {
      if (text) {
        this.dialogVisible = false;
        this.modifyText = '';
        this.$emit('modify', text)
      } else {
        this.$message.error('不能发送空消息！')
      }
    },
    // 清空标题接口
    async emptyTitle() {
      let param = {};
      if (this.aiModel === 1) {
        param = {
          programmeDetailId: this.programmeDetailId,
          programmeId: this.currentInfo.programmeId,
        }
      } else if (this.aiModel === 2) {
        param = {
          programmeDetailId: this.programmeDetailId,
          programmeId: this.currentInfo.programmeId,
          serviceId: this.currentInfo.serviceId
        }
      }
      let res = await sem.emptyTitle(param);
      if (res.data === 'success') {
        this.$message.success('已清空');
      }
    },
    // 清空方法
    clearTitle() {
      this.$confirm('清空已生成的数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('clear')
        this.emptyTitle();
      })
    },
    // 获取已保存的广告标题
    async getAdsTitle() {
      let res = await sem.getAdsTitle(this.programmeDetailId)
      this.savedTitleList = res.data.contentList || [];
      this.textarea = this.savedTitleList.join('\n')
    },
    // 保存标题接口
    async addAdsTitle() {
      let param = {
        saveType: 1,
        programmeDetailId: this.programmeDetailId,
        programmeId: this.currentInfo.programmeId,
        contentList: this.savedTitleList
      }
      await sem.addAdsTitle(param);
      await this.getAdsTitle();
    },
    // 添加关键词方法
    save(item) {
      if (this.savedTitleList.includes(item.content)) {
        this.$message.error('该标题已存在！');
      } else {
        this.savedTitleList.push(item.content);
        this.addAdsTitle();
      }
    },
    // 左边编辑、完成编辑
    edit() {
      this.readonly = !this.readonly;
      // 完成编辑时，转换为字符串数组，去重、去掉空字符串元素
      if (this.readonly) {
        this.savedTitleList = [...new Set(this.textarea.split('\n'))].filter(item => item !== "");
        this.addAdsTitle();
      }
    },
    // 左边复制
    copy() {
      // 复制文本到剪贴板
      navigator.clipboard.writeText(this.textarea)
          .then(() => {
            this.$message.success('文本已成功复制到剪贴板')
          })
          .catch((error) => {
            console.error('复制文本到剪贴板失败:', error);
            this.$message.error('复制文本到剪贴板失败')
          });
    },
    fillTo() {
      this.$emit('fillTo', this.savedTitleList)
    },
    addTo() {
      console.log('添加到账户')
    }
  }
}
</script>
<style lang="scss">
.titleCard {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 16px;
    border-left: 5px solid #52a4f8;
    box-sizing: border-box;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: space-between;


  }

  .left {
    width: 30%;


    .leftBox {
      width: 100%;
      border: 1px solid #999;
      border-radius: 4px;
      margin-top: 10px;
      box-sizing: border-box;
      padding: 0 10px;
      height: 600px;

      .btnBar {
        display: flex;
        justify-content: space-between;

        .total {
          line-height: 40px;
        }
      }
    }
  }

  .right {
    width: 65%;


    .rightBox {
      width: 100%;
      height: 600px;
      border: 1px solid #999;
      border-radius: 4px;
      margin-top: 10px;
      box-sizing: border-box;
      padding: 0 10px;
      overflow-y: auto;

      .btnBar {

        .total {
          line-height: 40px;
        }
      }

      .info {
        .listItem {
          height: 50px;
          position: relative;
          overflow: hidden;
          background-color: #fff;
          transition: background-color 0.3s ease;
          margin-bottom: 10px;

          &:hover {
            background-color: #eee;
          }

          &:hover .listItemRight {
            transform: translateY(-50px);
          }

          .listItemLeft {
            width: 100%;

            .leftTop, .leftBottom {
              box-sizing: border-box;
              padding: 0 10px;
              height: 24px;
              line-height: 24px;
              color: #333;
            }

            .leftBottom {
              color: #999;
            }
          }

          .listItemRight {
            width: 120px;
            line-height: 50px;
            position: absolute;
            top: 50px;
            right: 0;
            background-color: #eee;
            transition: transform 0.2s ease;

            .el-link {
              margin-right: 10px;
            }
          }
        }
      }

    }
  }
}
</style>